// extracted by mini-css-extract-plugin
export var card = "DashboardCard-module--card--1h8xK";
export var overlayLayer1 = "DashboardCard-module--overlayLayer1--uiGQ9";
export var overlayLayer2 = "DashboardCard-module--overlayLayer2--n-PNW";